export default __webpack_public_path__ + "static/media/d4a6b69c5e35f373ed00fe8cc861e36b.c49fe3c6.png";